import script from "./appbarView.vue?vue&type=script&setup=true&lang=js"
export * from "./appbarView.vue?vue&type=script&setup=true&lang=js"

import "./appbarView.vue?vue&type=style&index=0&id=496fdaa0&lang=css"

const __exports__ = script;

export default __exports__